/**
 * Starter fabrics for the Generate flow — values align with fabricAnalysisOptions / fabricTextures.
 */
export const DEFAULT_FABRIC_PRESETS = [
  {
    id: 'cotton-poplin',
    label: 'Cotton poplin',
    fabric_type: 'Poplin',
    weave_or_knit: 'Woven',
    opacity: 'Opaque',
    stretch: 'Non-stretch',
    gsm_weight: 'Light Weight (<150 GSM)',
  },
  {
    id: 'jersey-knit',
    label: 'Jersey knit',
    fabric_type: 'Jersey',
    weave_or_knit: 'Jersey knit',
    opacity: 'Opaque',
    stretch: 'Moderate stretch',
    gsm_weight: 'Mid Weight (150-260 GSM)',
  },
  {
    id: 'linen',
    label: 'Linen',
    fabric_type: 'Linen',
    weave_or_knit: 'Woven',
    opacity: 'Opaque',
    stretch: 'Non-stretch',
    gsm_weight: 'Mid Weight (150-260 GSM)',
  },
  {
    id: 'silk-charmeuse',
    label: 'Silk charmeuse',
    fabric_type: 'Charmeuse',
    weave_or_knit: 'Woven',
    opacity: 'Semi-transparent',
    stretch: 'Minimal stretch',
    gsm_weight: 'Light Weight (<150 GSM)',
  },
  {
    id: 'chiffon',
    label: 'Chiffon',
    fabric_type: 'Chiffon',
    weave_or_knit: 'Woven',
    opacity: 'Sheer',
    stretch: 'Minimal stretch',
    gsm_weight: 'Light Weight (<150 GSM)',
  },
  {
    id: 'denim',
    label: 'Denim',
    fabric_type: 'Denim',
    weave_or_knit: 'Woven',
    opacity: 'Opaque',
    stretch: 'Minimal stretch',
    gsm_weight: 'Heavy Weight (260+ GSM)',
  },
  {
    id: 'fleece',
    label: 'Polar fleece',
    fabric_type: 'Polar Fleece',
    weave_or_knit: 'Knitted',
    opacity: 'Opaque',
    stretch: 'Moderate stretch',
    gsm_weight: 'Heavy Weight (260+ GSM)',
  },
  {
    id: 'mesh',
    label: 'Sports mesh',
    fabric_type: 'Mesh/Net',
    weave_or_knit: 'Knitted',
    opacity: 'Semi-transparent',
    stretch: 'High stretch',
    gsm_weight: 'Light Weight (<150 GSM)',
  },
];
